import React from 'react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, toVND } from "../../../helpers/helpers";
import { DEFAULT_PRODUCT_IMAGE } from "../../../constants/images";
import { startOrder } from "../../../helpers/backend_helper";
import { getOrderDetail, markOrderAsUnclaimed } from "../../../slices/thunks";
import { AppDispatch } from "../../../store";

interface PaidOrderDetailProps {
    order: any;
}

const PaidOrderDetail: React.FC<PaidOrderDetailProps> = ({ order }) => {
    const { orderId } = useParams<{ orderId: string }>();
    const dispatch = useDispatch<AppDispatch>();
    const orderDetailState = useSelector((state: any) => state.OrderDetail ?? {});

    const items = order?.items || [];
    const total = order?.total || 0;
    const createdAt = order?.created_at || order?.createdAt;
    const isPaid = order?.is_paid;
    const orderStatus = order?.status ?? order?.order_status ?? order?.state;
    const normalizedStatus = typeof orderStatus === "string" ? orderStatus.toLowerCase() : orderStatus;

    const isMarkingUnclaimed = Boolean(orderDetailState?.loading?.markUnclaimed);

    const handleStartOrder = async () => {
        if (!orderId) return;
        try {
            await startOrder(orderId);
            dispatch(getOrderDetail(orderId));
        } catch (error) {
            console.error(error);
        }
    };

    const handleMarkUnclaimed = async () => {
        if (!orderId) return;

        try {
            await dispatch(markOrderAsUnclaimed({ orderId })).unwrap();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <React.Fragment>
            <div className="shipping-method-choose py-3">
                <div className="card shipping-method-choose-title-card">
                    <div className="card-body">
                        <h6 className="text-center mb-0">Thông tin đơn hàng</h6>
                    </div>
                </div>
                <div className="card shipping-method-choose-card">
                    <div className="card-body">
                        <div className="product-description w-100-v2 mw-100-v2 p-2">
                            <p className="text-dark fw-bold">Đơn hàng số: {order?.order_number}</p>
                            <p className="text-dark fw-bold">Thanh toán : <label
                                className={isPaid ? "text-success fw-bold" : "text-warning fw-bold"}>{isPaid ? "Đã thanh toán" : "Đợi thanh toán"}</label>
                            </p>
                            <p className="text-dark fw-bold">Tổng tiền : {toVND(total)}</p>
                            <p className="text-dark fw-bold">Đặt lúc
                                : {createdAt ? formatDate(createdAt, "HH:mm:ss") : "--"}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-wrapper-area">
                {items.length === 0 ? (
                    <div className="text-center py-5">
                        <p className="mb-3">Đơn hàng chưa có món</p>
                        <Link className="btn btn-primary" to="/home">Quay lại menu</Link>
                    </div>
                ) : (
                <div className="cart-table card mb-3">
                    <div className="table-responsive card-body">
                        <table className="table mb-0">
                            <tbody>
                            {items.map((item: any, i: number) => {
                                const productName = item.productName || item.product_name || item.name;
                                const price = item.price ?? item.unit_price ?? 0;
                                const quantity = item.quantity ?? item.qty ?? 0;
                                const image = item.imageUrl || item.image_url || DEFAULT_PRODUCT_IMAGE;

                                return (
                                    <tr key={i}>
                                        <td width="80">
                                            <img className="rounded mw-100-v2" src={image} alt=""/>
                                        </td>
                                        <td>
                                            <Link
                                                className="product-title"
                                                to="#"
                                            >
                                                {productName}
                                                <span className="mt-1">{toVND(price)} × {quantity}</span>
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                )}
            </div>
            <div className="position-fixed w-100 bottom-5-rem z-2 bg-white border-bottom">
                <div className="card cart-amount-area">
                    <div className="card-body d-flex align-items-center justify-content-between gap-2">
                        <h5 className="total-price mb-0 mb-md-0">
                            {toVND(total)}
                        </h5>
                        <div className="d-flex flex-grow-1 gap-2 justify-content-end">
                            {normalizedStatus !== "unclaimed" && (
                                <button
                                    className="btn btn-outline-warning"
                                    onClick={handleMarkUnclaimed}
                                    disabled={isMarkingUnclaimed}
                                >
                                    {isMarkingUnclaimed ? "Đang chuyển..." : "Khách chưa nhận"}
                                </button>
                            )}
                            <button className="btn btn-primary" onClick={handleStartOrder}>
                                Bắt đầu làm
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PaidOrderDetail;
